import React from 'react';

const StagingBanner = () => {
  return (
    <div className="bg-orange-500 text-center p-3 hidden">
      <p className="text-white text-sm">
        You are using the staging application. Any payments made are not real.
      </p>
    </div>
  );
};

export default StagingBanner;
